/**
 * Scroll Reveal — leve e sem dependências (IntersectionObserver).
 * Revela elementos com [data-reveal] ao entrarem na viewport.
 * Progressive enhancement: marca html.js-reveal; sem JS, tudo fica visível.
 */
(function () {
    document.documentElement.classList.add("js-reveal");

    function reveal() {
        var els = document.querySelectorAll("[data-reveal]");
        if (!els.length) return;

        var prefersReduced =
            window.matchMedia &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        if (prefersReduced || !("IntersectionObserver" in window)) {
            els.forEach(function (el) {
                el.classList.add("is-visible");
            });
            return;
        }

        var observer = new IntersectionObserver(
            function (entries, obs) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("is-visible");
                        obs.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
        );

        els.forEach(function (el) {
            observer.observe(el);
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", reveal);
    } else {
        reveal();
    }
})();
